import { JOINT_STATES } from './constants';

export const isCheckboxChecked = (state) => state !== JOINT_STATES.NOT_JOINT;
export const isFirstOrder = (state) => state === JOINT_STATES.FIRST_ORDER;
export const isAdditionalOrder = (state) =>
  state === JOINT_STATES.ADDITIONAL_ORDER;
